import { useSyncExternalStore } from "react";

/**
 * True only after client hydration. SSR + the first client render both
 * return false so markup can stay identical (shared-shell safe).
 *
 * Owner for hydrate-gated UI: import this hook — do not duplicate the
 * useSyncExternalStore snapshot pattern in layout components.
 */
function subscribeToHydration() {
  return () => {};
}

function getClientHydratedSnapshot() {
  return true;
}

function getServerHydratedSnapshot() {
  return false;
}

export function useIsHydrated(): boolean {
  return useSyncExternalStore(
    subscribeToHydration,
    getClientHydratedSnapshot,
    getServerHydratedSnapshot,
  );
}
